var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('el-container',[_c('el-aside',{attrs:{"width":"auto"}},[_c('common-menu-aside')],1),_c('el-container',[_c('el-header',[_c('common-header')],1),_c('el-main',{staticStyle:{"height":"80vh"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }